import * as React from 'react';
import { IMyHomeLayoutProps } from '../../types/myHomeForm';

import { Label } from '../../../common/packages/Label';
import { FilterWithButtonGroup } from '../../../common/packages/FilterWithButtonGroup';
import { AddressInput } from '../../../common/packages/AddressInput';
import { AreaInput } from '../../../common/packages/AreaInput';

import cn from 'clsx';
import * as styles from '../shared_my_home_styles.css';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { SwitchComponent } from '../../../common/packages/Switch';

export const LandComponent: React.FC<IMyHomeLayoutProps> = props => {
  return (
    <div className={styles['container']}>
      <form className={styles['form-content']} onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <div className={styles['form-content-item']}>
          <Label label="Тип недвижимости" />
          <FilterWithButtonGroup {...props.estimationTargetProps} testId="my_home_estimation_target_control" />
        </div>

        <div className={styles['form-content-item']}>
          <Label label="Адрес" />
          <AddressInput className={styles['form-content-fixed-height']} {...props.addressProps} />
        </div>

        <div className={cn(styles['form-content-item'], styles['form-content-suburban-items'])}>
          <div>
            <Label label="Площадь участка" />
            <AreaInput {...props.landAreaProps} />
          </div>
        </div>

        <div className={cn(styles['form-content-item'], styles['form-content-subscribe-item'])}>
          <div>
            <UIText1 color="black_100">Получать обновления цены</UIText1>
            <UIText2 color="gray60_100">Раз месяц будем рассказывать об изменениях на рынке</UIText2>
          </div>

          <div>
            <SwitchComponent {...props.switchProps} />
          </div>
        </div>
      </form>
    </div>
  );
};
